import React from 'react';
import { Checkbox, MenuItem, TextField } from '@mui/material';
import { FEditableGridColumn } from './types';
import type { FieldObject, FieldProps} from '../form';

type Props = { fieldobject: any; column?: FEditableGridColumn; value: any; error?: string; readonly?: boolean; onChange: (value: any) => void; };

//const EditableGridCell: React.FC<Props> = ({ column, value, error, readonly, onChange }) => {
class EditableGridField extends React.Component<Props, any> {

  render(){
    const {fieldobject,column,value,error,readonly,onChange} = this.props;
    // Integration note: replace this fallback with your framework formfields renderer for fa/df/jf/ms.
    //return <TextField size="small" value={value ?? ''} error={Boolean(error)} helperText={error || ''} fullWidth onChange={(e) => onChange(e.target.value)} />;
    const {fieldid,fieldcomponent,fieldprops={}} = fieldobject;
    const finalprops = {
      ...fieldprops,
      value,
      error:Boolean(error),
      slotProps:{ 
        htmlInput: { readOnly: readonly }, 
        paper:{sx:{width:'fit-content'}},
      }, 
      onChange,
    };
    const Field = (React.cloneElement(fieldcomponent,finalprops));
    return Field;
  }
}

export default EditableGridField;
 //{slotProps:{paper:{sx:{width:'fit-content'}}}}